import { Box, HStack } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { ColumnComponentProps } from '../../../types/activity-column-types';
import { ImageColumn } from './image-column';
import { ProductNameColumn } from './product-name-column';

type Props = ColumnComponentProps<BackofficeActivitiesOrderItem, string>;

export function ProductColumn({ info }: Props) {
  return (
    <HStack align="flex-start" spacing={3} minW={0} w="full">
      <Box flexShrink={0}>
        <ImageColumn info={info} />
      </Box>
      <Box flex={1} minW={0}>
        <ProductNameColumn info={info} />
      </Box>
    </HStack>
  );
}
